import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { useResponsive } from '@/contexts/ResponsiveContext';
import HorizontalLayout from '@/layout/Horizontal';
import ExpandedLayout from '@/layout/TopLayout/ExpandedLayout';
import { layout, LAYOUT_TYPE } from '@/settings';

const AppLayout = ({ children, ...props }) => {
  const { isMobile } = useResponsive();
  let Layout = HorizontalLayout;
  if (layout.type === LAYOUT_TYPE.TOP && !isMobile)
    Layout = ExpandedLayout;
  return (
    <Layout {...props}>
      {children}
    </Layout>
  );
};

export default memo(AppLayout);

AppLayout.propTypes = {
  children: PropTypes.any
};
